module.exports = __webpack_public_path__ + "img/chayot_no.021cd243.png";